import { Component } from "@/types"
import { Stack } from "@/ui/atoms/layout/Stack"
import { Title } from "@/ui/atoms/type/Title"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { cx } from "@/utils/cx"
import { tx } from "@/utils/tx"
import { Image } from "@/ui/atoms/media/Image"

export const COMPONENT_NAME = "syllabusCard"

export const presets = {}

export interface Props extends Component {
  title: string
  items: string[]
  image: string
}

export function SyllabusCard({ title, items, image, className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`rounded-lg overflow-hidden bg-white`, className)} data-test={testId}>
      <Image src={image} alt="" width={320} height={160} testId={tx(testId, "image")} />
      {/* Content */}
      <Stack className="p-4 gap-2">
        <Title size="sm" className="text-text" testId={tx(testId, "title")}>
          {title}
        </Title>
        <ul className="space-y-3">
          {items.map((item, index) => (
            <li key={index} className="flex items-start gap-2" data-test={tx(testId, "item", index.toString())}>
              <span className="size-2.5 block rounded-tl-sm rounded-br-sm bg-current shrink-0 mt-1.5"></span>
              <BodyText
                as="span"
                size="md"
                className="block font-light text-text leading-tight"
              >
                {item}
              </BodyText>
            </li>
          ))}
        </ul>
      </Stack>
    </div>
  )
}
